// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ggMap[data-v-71697310]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
